import { Product, ProductVariant } from '@shopify/theme-product-form'

export class ProductEvent extends Event {
  /**
   * @type {Product}
   */
  product = null

  /**
   * @type {ProductVariant}
   */
  variant = null

  constructor(name, { product, variant, ...options }) {
    super(name, options)

    if (!product) {
      throw new Error('product is required in product event data')
    }

    this.product = product
    this.variant = variant
  }
}

export class ProductFormEvent extends ProductEvent {
  /**
   * @type {HTMLFormElement}
   */
  form = null

  /**
   * @type {object}
   */
  options = null

  /**
   * @type {object}
   */
  properties = null

  /**
   * @type {number}
   */
  quantity = 0

  /**
   * @type {Event}
   */
  parentEvent = null

  constructor(
    name,
    { form, options, properties, quantity, parentEvent, ...eventOptions },
  ) {
    super(name, eventOptions)

    if (!form) {
      throw new Error('form is required in product form event data')
    }

    this.form = form
    this.options = options
    this.properties = properties
    this.quantity = quantity

    this.parentEvent = parentEvent
  }
}

export class ProductOptionChangeEvent extends ProductFormEvent {
  constructor(options) {
    super('product:option:change', options)
  }
}

export class ProductQuantityChangeEvent extends ProductFormEvent {
  constructor(options) {
    super('product:quantity:change', options)
  }
}

export class ProductPropertyChangeEvent extends ProductFormEvent {
  constructor(options) {
    super('product:property:change', options)
  }
}

export class ProductVariantChangeEvent extends ProductFormEvent {
  constructor(options) {
    super('product:variant:change', options)
  }
}
